import { gql } from '../../../__generated__/graphql/catalog'

export const CREATE_LOOP_RETURN_EXCHANGE_CART = gql(`
  mutation CreateLoopReturnExchangeCart($cartId: String!) {
    createLoopCart(cartToken: $cartId) {
      token
      error
    }
  }
`)
